// extracted by mini-css-extract-plugin
var _1 = "EmailRecipientsSelect-modulehiddenDropdown__Ht5HH Select-moduleSelect__MROu3";
export { _1 as "hiddenDropdown" }
